"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetReducer = void 0;
const core_1 = require("../../../core");
function widgetReducer(state = null, action) {
    if (!state) {
        return null;
    }
    return (0, core_1.widget)(state, action);
}
exports.widgetReducer = widgetReducer;
